import { render, staticRenderFns } from "./RelativePayment.vue?vue&type=template&id=4ce22fe6&scoped=true"
import script from "./RelativePayment.vue?vue&type=script&lang=js"
export * from "./RelativePayment.vue?vue&type=script&lang=js"
import style0 from "./RelativePayment.vue?vue&type=style&index=0&id=4ce22fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce22fe6",
  null
  
)

export default component.exports